import React from 'react';
import UserAvatar from './UserAvatar';
import '../styles/TripMetaGrid.css';

const TripMetaGrid = ({
  className = '',
  includeContractCostCenter = false,
  customerName = '--',
  vehicleLabel = '--',
  driverName = '--',
  driverContact = '--',
  driverImage = '',
  contractCostCenter = '--',
}) => (
  <div className={`completed_meta_grid ${includeContractCostCenter ? 'has_contract_cost_center' : ''} ${className}`.trim()}>
    <div className="meta_item">
      <span className="meta_label">Customer</span>
      <span className="meta_val">{customerName || '--'}</span>
    </div>
    <div className="meta_item">
      <span className="meta_label">Vehicle</span>
      <span className="meta_val">
        <a href="#vehicle" className="meta_link_blue">{vehicleLabel || '--'}</a>
      </span>
    </div>
    <div className="meta_item">
      <span className="meta_label">Driver</span>
      <div className="driver_val_row">
        <UserAvatar
          username={driverName || ''}
          image={driverImage || ''}
          size={24}
          fontSize="10px"
          marginRight="0"
        />
        <span className="driver_link_purple">{driverName || '--'}</span>
      </div>
    </div>
    <div className="meta_item">
      <span className="meta_label">Driver Contact</span>
      <span className="meta_val">{driverContact || '--'}</span>
    </div>
    {includeContractCostCenter ? (
      <div className="meta_item">
        <span className="meta_label">Contract &middot; Cost Center</span>
        <span className="meta_val">{contractCostCenter || '--'}</span>
      </div>
    ) : null}
  </div>
);

export default TripMetaGrid;
